// Playtime constants (in seconds). Centralised so tests + UI stay in sync.
export const SOFT_BREAK_AT = 8 * 60;      // 8 minutes of play → first friendly nudge
export const SNOOZE_SECONDS = 5 * 60;     // "keep playing" delays the nudge by 5 minutes
export const HARD_CAP = 45 * 60;          // 45 minutes today → games get locked until a break
export const ZEN_REWARD = 30;
export const YOGA_REWARD = 40;
